//******************************//
environment_array = {
    'window_width': $(window).width(),
    'window_height': $(window).height(),
    'scroll': 0,
    'scroll_detected': true,
    'scroll_history': 0,
    'breakpoint': 767
};
//******************************//

//******************************//
function pgControl(object){

    //******************************//
    if(object.action == "setup"){

        //******************************//
        /* -- Click -- */
        $("[data-trigger='js']").unbind().click(function(event){

            /* -- Youtube Player Embed -- */
            if(
                $(this).attr("data-trigger-type") == "_youtube" &&
                $("[id='"+$(this).attr("data-embed-code")+"']").length > 0
            ){
                var code = $(this).attr("data-embed-code");
                $("[id='"+code+"']").addClass("active");
                $(this).parent().addClass("_disabled");
                pauseAllVideos({'ignore': code });
                setTimeout(function(){
                    players[code].playVideo();
                }, 1000);
                event.preventDefault();
                return;
            }

            /* -- Navigation Related -- */
            if($(this).attr("data-trigger-type") == "nav"){
                if(environment_array.window_width <= environment_array.breakpoint){
                    if(!$(this).parent().find(".nav-sub").hasClass("_expanded")){
                        $("._nav > ul > li").removeClass("_expand");
                        $(".nav-sub").removeClass("_expanded");
                        $(this).parent().addClass("_expand");
                        $(this).parent().find(".nav-sub").addClass("_expanded");
                    }else{
                        $(this).parent().removeClass("_expand");
                        $(this).parent().find(".nav-sub").removeClass("_expanded");
                    }  
                    event.preventDefault();
                    return;
                }
            }

            /* -- Navigation Related (#Shop) -- */
            if($(this).attr("data-trigger-type") == "shop"){
                /* -- Level 1 (Control) -- */
                if(
                    $(this).attr("data-level") != undefined &&
                    parseInt($(this).attr("data-level")) == 1
                ){
                    $("._nav * ._master * a").removeClass("_selected");
                    $(this).addClass("_selected");
                    $("._nav * ._content > div").attr({'data-display': 0});
                    $("._nav * ._content > [data-parent-id='"+$(this).attr("data-id")+"']").attr({'data-display': 1});
                    event.preventDefault();
                    return;
                }

                /* -- Level 2 (Control) -- */
                if(
                    $(this).attr("data-level") != undefined &&
                    parseInt($(this).attr("data-level")) == 2
                ){
                    if(environment_array.window_width <= environment_array.breakpoint){
                        /* -- Ignore -- */
                        customResponsiveNavigation({'action': 'close'});
                    }else{
                        $("._nav * [data-level='4']").attr({'data-default-id': $(this).attr("data-id") });
                        $("._nav * [data-level='4'] > div").attr({'data-display': 0});
                        $("._nav * [data-level='4'] [data-parent-id='"+$(this).attr("data-id")+"']").attr({'data-display': 1});
                        $("._nav * ._content > div [data-level='2'] * a").removeClass("_selected");
                        $(this).addClass("_selected");
                        $("._nav * ._content > div [data-level='3'] > ul").attr({'data-display': 0});
                        $("._nav * ._content > div [data-level='3'] > [data-parent-id='"+$(this).attr("data-id")+"']").attr({'data-display': 1});
                        event.preventDefault();
                        return;
                    }
                }

                /* -- Level 3 (Control) -- */
                if(
                    $(this).attr("data-level") != undefined &&
                    parseInt($(this).attr("data-level")) == 3 &&
                    $(this).hasClass("_view_all")
                ){
                    $(".nav-sub").removeClass("_expanded");
                }
            }

            if($(this).attr("data-trigger-type") == "close-menu"){
                if(environment_array.window_width >= environment_array.breakpoint){
                    /* -- Ignore -- */
                    $(".nav-sub").removeClass("_expanded");
                    responsiveControl({'action': "resize"});
                }
            }

        });
        //******************************//

        //******************************//
        /* -- Navigation Related (Main Menu) -- */
        $("._nav > ul._level1 > li").mouseenter(function(){
            if(environment_array.window_width > environment_array.breakpoint){
                if($(this).parent().hasClass("_level1")){
                    $(this).addClass("_active");
                    $(".nav-sub").removeClass("_expanded");
                    $(this).find(".nav-sub").addClass("_expanded");
                    responsiveControl({'action': "resize"});
                }
            }
        });
        $("._nav > ul._level1 > li").mouseleave(function(){
            if(environment_array.window_width > environment_array.breakpoint){
                if($(this).parent().hasClass("_level1")){
                    $(this).removeClass("_active");
                    $(".nav-sub").removeClass("_expanded");
                    responsiveControl({'action': "resize"});
                }
            }
        });
        //******************************//

        //******************************//
        $("._nav * [data-level='3'] * a").mouseenter(function(){
            if(!parseInt($(this).attr("data-ignore"))){
                $("._nav * [data-level='4'] > div").attr({'data-display': 0});
                if($(this).attr("data-id") != undefined){
                    $("._nav * [data-level='4'] [data-parent-id='"+$(this).attr("data-id")+"']").attr({'data-display': 1});
                }
            }
        });

        $("._nav * [data-level='3'] * a").mouseleave(function(){
            if(!parseInt($(this).attr("data-ignore"))){
                $("._nav * [data-level='4'] > div").attr({'data-display': 0});
                $("._nav * [data-level='4'] [data-parent-id='"+$("._nav * [data-level='4']").attr("data-default-id")+"']").attr({'data-display': 1});
            }        
        });
        //******************************//

        //******************************//
        /* -- Booking Form (Shortcuts Software) -- */
        var shortcutsScript = document.createElement('script');
        
        shortcutsScript.src = "https://bookingscontent.shortcutssoftware.com/ols-onlinebooking-ui/assets/ols-widget/dist/ols-widget.min.js";
        shortcutsScript.type = "text/javascript";
        shortcutsScript.defer = false;

        shortcutsScript.setAttribute('data-origin', 'https://home.shortcutssoftware.com/vanclarke');
        shortcutsScript.setAttribute('data-company-id', '285');
        shortcutsScript.setAttribute('data-widget', '_m');
        shortcutsScript.setAttribute('data-floating-button', 'True');
        shortcutsScript.setAttribute('data-floating-button-text', 'Book Now');
        shortcutsScript.setAttribute('data-floating-button-color', '#D1C6C2');
        shortcutsScript.setAttribute('data-floating-button-text-color', '#000000');
        shortcutsScript.setAttribute('data-side-widget-position', 'right');
        shortcutsScript.setAttribute('data-floating-button-position', 'right');

        document.body.appendChild(shortcutsScript);
        //******************************//

        //******************************//
        customResponsiveNavigation({'action': "setup"});
        //******************************//

        //******************************//
        responsiveControl({'action': "resize"});
        //******************************//

        //******************************//
        $("._nav").css({'opacity': 1 });
        //******************************//

        //******************************//
        /* -- Hash (Anchor Scroll Position) -- */
        setTimeout(function(){
            var hash = window.location.hash.slice(1);
            if(
                hash != undefined &&
                hash != null &&
                hash != ""
            ){
                anchorControl({'id': hash});
            }
        }, 500);
        //******************************//

        //******************************//
        /* -- Delayed Screen Refresh -- */
        setTimeout(function(){
            responsiveControl({'action': "resize"});
        }, 1000);
        //******************************//

    }
    //******************************//

}
//******************************//

//******************************//
function anchorControl(object){
    if($("[anchor-id='"+object.id+"']").length > 0){
        setTimeout(function(){
            scrollAnimate({'position_x': 0, 'position_y': ($("[anchor-id='"+object.id+"']").offset().top-$(".shopify-section.header-section").height()), 'speed': 0});
        }, 1000);
    }
}
//******************************//

//******************************//
function customResponsiveNavigation(object){

  var storage = {
    'header': {
      'h1': 0,
      'h2': 0
    }
  };

  if(object.action == "setup"){
    $(".nav-toggle").unbind().click(function(){
      if($(".nav-toggle").hasClass("open")){
        customResponsiveNavigation({'action': 'close'});
      }else{
        customResponsiveNavigation({'action': 'open'});
      }
    });
  }

  if(object.action == "open"){
    $(".nav-toggle, ._nav").removeClass("closed").addClass("open");
    responsiveControl({'action': "resize"});
  }

  if(object.action == "close"){
    $(".nav-toggle, ._nav").removeClass("open").addClass("closed");
    responsiveControl({'action': "resize"});
  }

  if(object.action == "display"){
    if($(window).width() <= environment_array.breakpoint){
      $(".header .primary").css({'height': ($(window).height()+120) });
      $(".header .primary > ul").css({'height': $(window).height() });
    }else{
      $(".header .primary").css({'height': "auto" });
      $(".header .primary > ul").css({'height': "auto" });
    }
  }
}
//******************************//

//******************************//
function responsiveControl(object){

    //**************//
    environment_array.window_width = $(window).width();
    environment_array.window_height = $(window).height();
    environment_array.scroll = $(window).scrollTop();
    //**************//

    //**************//
    var responsive = {
        'nav': {
            'h': 0,
            'select': {
                'left': null,
                'width': null
            },
            'active': {},
            'header': {
                'announcementBar': 0,
                'top_bar': 0,
                'logo': 0,
                'total': 0
            }
        }
    }
    //**************//

    //**************//
    if(environment_array.window_width > environment_array.breakpoint){
        if($("[data-selected-tab='1']").length > 0){
            responsive.nav.select = {
                'left': $("[data-selected-tab='1']").parent().find('span').first().position().left,
                'width': $("[data-selected-tab='1']").parent().find('span').first().width()
            };
        }
        if($("._nav > ul._level1 > li._active").length > 0){
            responsive.nav.active = {
                'left': $("._nav > ul._level1 > li._active").find('span').first().position().left,
                'width': $("._nav > ul._level1 > li._active").find('span').first().width()
            };
        }
        if(
            responsive.nav.active.left != null ||
            responsive.nav.select.left != null
        ){
            $("._nav > ._bar").css({'opacity': 1, 'width': (responsive.nav.active.width != null ? responsive.nav.active.width : responsive.nav.select.width), 'left': (responsive.nav.active.left != null ? responsive.nav.active.left : responsive.nav.select.left) }, 300);
        }else{
            $("._nav > ._bar").removeAttr("style");
        }
    }else{
        $("._nav > ._bar").removeAttr("style");
    }
    //**************//

    //**************//
    if(environment_array.window_width <= environment_array.breakpoint){
        responsive.nav.header.announcementBar = $(".shopify-section.header-section > .announcementBar").height();
        responsive.nav.header.top_bar = $(".shopify-section.header-section > .top_bar").height();
        responsive.nav.header.logo = $(".shopify-section.header-section * .header-logo").height();
        responsive.nav.header.total += (responsive.nav.header.announcementBar != null ? responsive.nav.header.announcementBar : 0);
        responsive.nav.header.total += (responsive.nav.header.top_bar != null ? responsive.nav.header.top_bar : 0);
        responsive.nav.header.total += (responsive.nav.header.logo != null ? responsive.nav.header.logo : 0);
        $("._nav.open").css({'height': "calc(100dvh - "+Math.round(responsive.nav.header.total)+"px)" });
    }else{
        $("._nav.open").removeAttr("style");
    }
    //**************//

}
//******************************//

//******************************//
/* -- Youtube API -- */
var tag = document.createElement('script');
tag.src = "https://www.youtube.com/iframe_api";
var firstScriptTag = document.getElementsByTagName('script')[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
var players = {};

function onYouTubeIframeAPIReady() {
    $('iframe[src*="youtube.com"]').each(function() {
        var player = new YT.Player(this);
        players[$(this).attr("id")] = player;
    });
}

function pauseAllVideos(object) {
    $.each(players, function(key, player) {
        if(key != object.ignore){
            player.pauseVideo();
        }
    });
}
//******************************//

//******************************//
function scrollAnimate(object){
  $("html, body").animate({scrollTop: object.position_y, scrollLeft: object.position_x }, object.speed).promise().then(function(){});
}
//******************************//

//******************************//
$(window).on('hashchange', function() {
    var hash = window.location.hash.slice(1);
    if(
        hash != undefined &&
        hash != null &&
        hash != ""
    ){
        anchorControl({'id': hash});
    }
});
//******************************//

//******************************//
$(window).scroll(function(){
  environment_array.scroll_detected = true;
  responsiveControl({'action': "scroll"});
});
//******************************//

//******************************//
$(window).resize(function(){
  responsiveControl({'action': "resize"});
});
//******************************//

//******************************//
function waitForjQuery(callback) {
    if (window.jQuery) {
        callback(jQuery);
    } else {
        setTimeout(function() { waitForjQuery(callback); }, 50);
    }
}
//******************************//

//******************************//
waitForjQuery(function($) {
    $(document).ready(function() {
        pgControl({'action': "setup"});
    });
});
//******************************//